import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import BackLink from '../../../Components/BackLink'
import BookingForm from './BookingForm'
import { bookingSchema } from '../../../schemas'

export default function New({ account, accounts, navigation, venues, packages }) {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  const defaultDate = tomorrow.toISOString().split('T')[0]

  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Booking"
    >
      <BackLink href="/manage/bookings">Back to Bookings</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={bookingSchema}
          resource="booking"
          endpoint="/manage/bookings"
          backLink="/manage/bookings"
          submitLabel="Create Booking"
          defaultValues={{
            guest_name: '',
            guest_email: '',
            guest_phone: '',
            date: defaultDate,
            time: '12:00',
            party_size: 2,
            venue_id: '',
            package_id: '',
            total_pence: 0,
            notes: '',
            internal_notes: ''
          }}
        >
          {({ control, errors }) => (
            <BookingForm
              control={control}
              errors={errors}
              venues={venues}
              packages={packages}
            />
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
